var BxfButtonSizeEnum;
(function (BxfButtonSizeEnum) {
    BxfButtonSizeEnum["XSMALL"] = "xsmall";
    BxfButtonSizeEnum["SMALL"] = "small";
    BxfButtonSizeEnum["REGULAR"] = "regular";
    BxfButtonSizeEnum["LARGE"] = "large";
    BxfButtonSizeEnum["BLOCK"] = "block";
    BxfButtonSizeEnum["CARD"] = "card";
})(BxfButtonSizeEnum || (BxfButtonSizeEnum = {}));

export { BxfButtonSizeEnum as B };
